<template>
  <ul class="modify-user">
    <li v-for="staff in staffList" :key="staff.id">
      <button :class="{ selected: staff.id === selectedId }" @click="select(staff)">{{ staff.name }}</button>
    </li>
  </ul>
</template>

<script>
/**
 * スタッフ選択
 */
export default {
  name: 'StaffSelect',
  props: {
    /** スタッフのリスト */
    staffList: Array,
    /** 選択済みのスタッフID */
    selectedId: Number,
  },
  methods: {
    select(staff) {
      /**
       * スタッフ選択
       *
       * @event select
       * @type {object}
       */
      this.$emit('select', staff)
    },
  },
}
</script>

<style lang="postcss" scoped>
.modify-user {
  border-radius: 8px;
  max-height: 320px;
  overflow-x: hidden;
  overflow-y: scroll;
  width: 248px;

  li {
    position: relative;

    button {
      appearance: none;
      background-color: var(--white);
      border: 0;
      border-radius: 0;
      color: var(--text-color);
      cursor: pointer;
      font-family: inherit;
      font-size: 18px;
      height: 56px;
      margin: 0 16px;
      outline: none;
      overflow: hidden;
      padding: 0;
      text-align: left;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: stretch;

      &::after {
        background-color: var(--border-color);
        bottom: 0;
        content: '';
        height: 1px;
        left: 0;
        margin: 0 8px;
        position: absolute;
        width: 232px;
      }
    }

    &:last-child {
      button::after {
        display: none;
      }
    }
  }

  .selected {
    background-color: var(--very-light-yellow);
  }

  .responsive & {
    @media screen and (--sp-size) {
      max-height: 224px;
      width: 256px;

      button {
        font-size: 15px;
        height: 48px;
      }
    }
  }
}
</style>
